import { requestWithAuthorization } from './requestWithAuthorization';
import PortalConfigure from '@/portal-configure';
import { LoginInfo, ErrorInfo } from '@/types/type';

export const updateUserSchema = async (
  loginInfo: LoginInfo,
  userAnonymousId: string
): Promise<void> => {
  let error: Error = { name: '', message: '' };
  await requestWithAuthorization
    .post(PortalConfigure.API.UpdateUserSchema, {
      ...loginInfo,
      userAnonymousId,
    })
    .catch((e: Error) => {
      error = e;
    });
  if (error && error.message) {
    const errorInfo: ErrorInfo = {
      code: 'E00003',
      title: 'Error in update user schema',
      message: error.message,
      args: loginInfo,
    };
    error.message = JSON.stringify(errorInfo);
    throw error;
  }
};
